/* Kahwa — About page scroll behaviour.
   Reveals sections and milestones on entry and grows the timeline spine
   as the reader moves through it. Honours prefers-reduced-motion and
   degrades to fully visible content when IntersectionObserver is absent. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.kabInit === '1') return;
    root.dataset.kabInit = '1';

    var reduced =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var revealables = root.querySelectorAll('.kab-reveal, .kab__ms');

    if (reduced || !('IntersectionObserver' in window)) {
      for (var i = 0; i < revealables.length; i++) {
        revealables[i].classList.add('is-in');
      }
      var staticFill = root.querySelector('.kab__tl__fill');
      if (staticFill) staticFill.style.height = '100%';
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.15 }
    );

    for (var j = 0; j < revealables.length; j++) {
      observer.observe(revealables[j]);
    }

    /* Timeline spine fill */
    var list = root.querySelector('.kab__tl__track');
    var fill = root.querySelector('.kab__tl__fill');
    if (!list || !fill) return;

    var ticking = false;

    function paint() {
      ticking = false;
      var rect = list.getBoundingClientRect();
      var anchor = window.innerHeight * 0.55;
      var travelled = anchor - rect.top;
      var pct = (travelled / rect.height) * 100;
      if (pct < 0) pct = 0;
      if (pct > 100) pct = 100;
      fill.style.height = pct.toFixed(2) + '%';
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(paint);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    paint();
  }

  function boot() {
    var roots = document.querySelectorAll('.kab');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor: re-run when the section is re-rendered. */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('.kab') : null;
    if (el) init(el);
  });
})();
